"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Benefit() {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: footerRef,
    isVisible: footerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  return <section data-section-id="3202" id="benefits" className="dark bg-background text-foreground relative overflow-hidden py-24 md:py-40">
      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.04]" style={{
      backgroundImage: "repeating-linear-gradient(90deg, var(--foreground) 0px, var(--foreground) 1px, transparent 1px, transparent 3px)"
    }} aria-hidden="true" />

      {}
      <svg className="pointer-events-none absolute bottom-0 right-0 w-[420px] max-w-[60%] opacity-[0.06]" viewBox="0 0 600 200" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M0 180 Q 60 160 120 170 T 240 165 Q 300 155 360 170 T 480 168 Q 540 158 600 172" stroke="currentColor" strokeWidth="1" fill="none" />
        <path d="M0 185 Q 80 175 160 180 T 320 178 Q 400 170 480 182 T 600 180" stroke="currentColor" strokeWidth="1" fill="none" />
        <path d="M60 170 L 80 150 L 100 170 Z M 200 165 L 230 135 L 260 165 Z M 380 168 L 410 142 L 440 168 Z" stroke="currentColor" strokeWidth="1" fill="none" />
      </svg>

      <div className="relative mx-auto max-w-7xl px-6 md:px-10">
        {}
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12 md:gap-8">
          {}
          <div ref={headingRef} className={`md:col-span-8 transition-all duration-1000 ease-out ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <h2 className="font-default font-bold leading-[1.05] tracking-tight text-foreground" style={{
            fontSize: "clamp(3rem, 6vw, 6rem)"
          }}>
              Unlock digital potential.{" "}
              <em className="italic text-primary font-bold">Instantly</em>.
            </h2>

            <p className="mt-8 max-w-lg font-default text-lg leading-relaxed text-foreground/80 md:text-xl">
              Whether you are optimizing your home network or securing enterprise-grade infrastructure, our AI-driven tools provide the precision you need. Choose a path below — we will guide you toward total digital sovereignty.
            </p>
          </div>

          {}
          <div ref={ctaRef} className={`md:col-span-4 flex flex-col justify-end gap-4 transition-all duration-1000 ease-out delay-200 ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <Button asChild className="group h-auto rounded-lg bg-primary px-10 py-5 text-base font-medium text-primary-foreground hover:bg-primary/90 shadow-md w-full">
              <Link to="/AiToolsAIGenixPage">
                <span>Explore AI Tools</span>
                <ArrowRight className="ml-2 size-4 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </Button>

            <Button asChild variant="outline" className="group h-auto rounded-lg border border-foreground bg-transparent px-10 py-5 text-base font-medium text-foreground hover:bg-foreground hover:text-background w-full">
              <Link to="https://vpngenix.com/go/NordVPN" newTab>
                <span>Secure Your Connection</span>
                <ArrowRight className="ml-2 size-4 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </Button>
          </div>
        </div>

        {}
        <div className="mt-20 h-px w-full bg-foreground/20" />

        {}
        <div ref={footerRef} className={`mt-8 flex flex-col gap-4 md:flex-row md:items-center md:justify-between transition-all duration-1000 ease-out delay-300 ${footerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <p className="font-default text-base text-foreground/70 md:text-lg">
            Or contact our support team —{" "}
            <Link to="mailto:support@vpngenix.com" className="text-foreground underline-offset-4 hover:underline">
              support@vpngenix.com
            </Link>
          </p>

          <p className="font-mono text-xs uppercase tracking-widest text-foreground/60">
            System Status / Online / 24—7 Global
          </p>
        </div>
      </div>
    </section>;
}